export const FILING_CONFIRMATION_FILE_CONFIG = {
  maxSize: 100 * 1024 * 1024, // 100MB
  acceptedTypes: {
    'application/pdf': ['.pdf'],
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
  },
  message: 'PNG, JPG & PDF accepted (max. 100 MB)',
};

export const PAYMENT_CONFIRMATION_FILE_CONFIG = {
  maxSize: 100 * 1024 * 1024, // 100MB
  acceptedTypes: {
    'application/pdf': ['.pdf'],
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
  },
  message: 'PNG, JPG & PDF accepted (max. 100 MB)',
};
